import { render, staticRenderFns } from "./NhStatsStrip.vue?vue&type=template&id=16e050cc"
import script from "./NhStatsStrip.vue?vue&type=script&lang=js"
export * from "./NhStatsStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports